import { Id } from '@shared/types/id';

export class EquipmentReportParameter {
  constructor(
    readonly id: Id,
    readonly name: string,
    readonly value: string
  ) {}
}
